import { createNamespacedHelpers } from 'vuex'

const {
  mapActions: mapActionsSearch,
  mapState: mapStateSearch,
} = createNamespacedHelpers('search')

export default ({ store }, inject) => {
  const searchActions = {
    $store: store,
    ...mapActionsSearch([
      'setResults',
      'updateFilters',
    ]),
  }

  const searchState = {
    $store: store,
    ...mapStateSearch({
      products: state => state.products,
      aggregations: state => state.aggregations,
      category: state => state.category,
      articles: state => state.articles,
      filters: state => state.filters,
      perPage: state => state.perPage,
      isPending: state => state.isPending,
      productsTotalCount: state => state.productsTotalCount,
      productsTotalPages: state => state.productsTotalPages,
      productSort: state => state.productSort,
    }),
  }

  inject('search', {
    ...searchState,
    ...searchActions,
  })
}
